var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaSchliessfach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#309eed;}.cls-3{fill:#2479d2;}.cls-4{fill:#a3ccee;}.cls-5{fill:#74bef3;}.cls-6{fill:#ffbf14;}.cls-7{fill:#e0a812;}.cls-8{fill:#423e38;}.cls-9{fill:#949494;}.cls-10{fill:#f2b134;}.cls-11{fill:#302e29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.62,8H25.33A7.34,7.34,0,0,0,18,15.34V123.62A7.34,7.34,0,0,0,25.33,131H133.61a7.34,7.34,0,0,0,7.34-7.34V15.34A7.33,7.33,0,0,0,133.62,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.62,8H124.5a7.34,7.34,0,0,1,7.34,7.34V123.62A7.34,7.34,0,0,1,124.5,131h9.12a7.34,7.34,0,0,0,7.33-7.34V15.34A7.33,7.33,0,0,0,133.62,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.34,22.28H34.6a2.33,2.33,0,0,0-2.33,2.33V35.19h0a3.1,3.1,0,0,1,3.1,3.11V56.42a3.1,3.1,0,0,1-3.1,3.1h0V79.44h0a3.1,3.1,0,0,1,3.1,3.1v18.12a3.1,3.1,0,0,1-3.1,3.1h0v10.59a2.33,2.33,0,0,0,2.33,2.33h89.74a2.33,2.33,0,0,0,2.33-2.33V24.61a2.33,2.33,0,0,0-2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.34,22.28H112.28a2.33,2.33,0,0,1,2.33,2.33v89.74a2.33,2.33,0,0,1-2.33,2.33h12.06a2.33,2.33,0,0,0,2.33-2.33V24.61a2.33,2.33,0,0,0-2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.41,59.52H18V35.19H32.41a3,3,0,0,1,3,3v18.3a3,3,0,0,1-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.32,35.19H25.94A3.1,3.1,0,0,1,29,38.3V56.42a3.1,3.1,0,0,1-3.1,3.1h6.38a3.1,3.1,0,0,0,3.1-3.1V38.3a3.1,3.1,0,0,0-3.1-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.41,103.76H18V79.44H32.41a3,3,0,0,1,3,3v18.3a3,3,0,0,1-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.32,79.44h-5.8a3.1,3.1,0,0,1,3.1,3.1v18.12a3.1,3.1,0,0,1-3.1,3.1h5.8a3.1,3.1,0,0,0,3.1-3.1V82.54a3.1,3.1,0,0,0-3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M99.55,69.48A20.08,20.08,0,1,1,79.47,49.4,20.08,20.08,0,0,1,99.55,69.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.11,69.48a7.64,7.64,0,1,1-7.64-7.64,7.64,7.64,0,0,1,7.64,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.38,91.81a4.79,4.79,0,0,1-4.78-5l1.78-36.31a2.16,2.16,0,0,1,2.16-2h1.69a2.15,2.15,0,0,1,2.15,2l1.78,36.31a4.78,4.78,0,0,1-4.78,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.26,52.92h-3.05a2.89,2.89,0,1,0,0,5.77H110Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M119.55,52.92h-3l.28,5.77h2.77a2.89,2.89,0,1,0,0-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.61,152H45.48a3.35,3.35,0,0,1-3.29-2.71L38.69,131H61.4l-3.51,18.33A3.33,3.33,0,0,1,54.61,152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53.38,131l-3.5,18.33A3.34,3.34,0,0,1,46.6,152h8a3.33,3.33,0,0,0,3.28-2.71L61.4,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.47,152h-9.14a3.34,3.34,0,0,1-3.28-2.71L97.55,131h22.7l-3.5,18.33a3.34,3.34,0,0,1-3.28,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M111.87,131l-3.5,18.33a3.34,3.34,0,0,1-3.28,2.71h8.38a3.34,3.34,0,0,0,3.28-2.71l3.5-18.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.47,59.59a2.18,2.18,0,0,0,2.18-2.18V55.76a2.18,2.18,0,0,0-4.35,0v1.65a2.17,2.17,0,0,0,2.17,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.54,62.49l1.17-1.17a2.18,2.18,0,0,0-3.08-3.08l-1.17,1.17a2.18,2.18,0,1,0,3.08,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.36,69.48a2.18,2.18,0,0,0,2.18,2.17h1.65a2.17,2.17,0,1,0,0-4.34H91.54a2.18,2.18,0,0,0-2.18,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.54,76.47a2.18,2.18,0,1,0-3.08,3.08c.88.73,1.37,1.8,2.71,1.8a2.18,2.18,0,0,0,1.54-3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.65,83.19V81.54a2.18,2.18,0,0,0-4.35,0v1.65a2.18,2.18,0,1,0,4.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.4,76.47l-1.16,1.17a2.17,2.17,0,0,0,3.07,3.07l1.17-1.16a2.18,2.18,0,0,0-3.08-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.58,69.48a2.17,2.17,0,0,0-2.17-2.17H65.76a2.17,2.17,0,1,0,0,4.34h1.65a2.17,2.17,0,0,0,2.17-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.94,63.12a2.18,2.18,0,0,0,1.54-3.71l-1.17-1.17a2.17,2.17,0,0,0-3.07,3.08c.87.73,1.36,1.8,2.7,1.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaSchliessfach);
export default __webpack_public_path__ + "static/media/ka_schliessfach.70b4af69bf99e1c8cc44d28e3aeefb96.svg";
export { ForwardRef as ReactComponent };